import React from 'react';
import CircleButton from '../../components/CircleButton/CircleButton';
import './Footer.scss';

import { CommonConfig, Icons } from '../../config';

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <p>
                    Copyright &copy; {new Date().getFullYear()} All rights reserved
                </p>

                <p>
                    <a href="mailto:chainmateservices@gmail.com">chainmateservices@gmail.com</a> | 
                    <a href="https://twitter.com/0xChainmates" target="_blank" rel="noopener noreferrer"> @0xchainmates</a>
                </p>
            </div>
        );
    }
}

export default Footer;